var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zul-modal',{ref:"modal",staticClass:"is-small three-ds-auth-modal",attrs:{"id":"three-ds-auth-modal","title":"Autenticar cartão"}},[(_vm.isLoading)?_c('p',{staticClass:"loading"},[_vm._v(_vm._s(_vm.$t("global.loading")))]):_vm._e(),_c('div',{ref:"challengeContainerRef",attrs:{"id":"challenge-container-ref"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }